import { fetcher } from '@commenda/utils';

export async function createTaxAndReportingOnboarding(
  corporationId: number
): Promise<Response> {
  return await fetcher('tax-and-accounting/onboarding', {
    method: 'POST',
    body: {
      corporationId,
    },
  });
}
